import { render, staticRenderFns } from "./BodyDaTabela.vue?vue&type=template&id=5e437a08&scoped=true"
import script from "./BodyDaTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDaTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDaTabela.vue?vue&type=style&index=0&id=5e437a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e437a08",
  null
  
)

export default component.exports